import React from 'react'
import styles from "./tnpsc-gr-iv-test-batch-2023.module.css";
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import Link from 'next/link';
import Head from 'next/head';

const Tnpsc_gr_IV_testbatch = () => {
    return (
        <>

        <Head>
            <meta charset="UTF-8" />
            <link rel="icon" href="./logo.png" />
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta name="robots" content="noodp,noydir" />
            <meta name="robots" content="index,follow" />
            <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
            <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
            <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
            <title>TNPSC Gr-Ⅳ Test Batch 2023 - Shankar IAS Academy</title>
            <meta name="title" content="TNPSC Gr-Ⅳ Test Batch 2023 - Shankar IAS Academy" />
            <meta name="description" content="" />
            <link rel="canonical" href="https://www.shankariasacademy.com/tnpsc-gr-iv-test-batch-2023/ " />
            <meta property="og:locale" content="en_US" />
            <meta property="og:type" content="article" />
            <meta property="og:title" content="TNPSC Gr-Ⅳ Test Batch 2023 - Shankar IAS Academy" />
            <meta property="og:description" content="" />
            <meta property="og:url" content="https://www.shankariasacademy.com/tnpsc-gr-iv-test-batch-2023/ " />
            <meta property="og:site_name" content="Shankar IAS Academy" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:site" content="@shankarias" />
        </Head>

            <Navbar title="tnpsc" />

            <div className="container">
                <div className="pt-3 pt-md-5">
                    <h1 className={`${styles.pagemaintitle}`}>TNPSC Gr-<b>Ⅳ</b> Test Batch 2024 - Shankar IAS Academy</h1>
                </div>
            </div>


            <div className="container">
                <div className='py-2' style={{backgroundColor: "#001e62"}}>
                <h1 className={`${styles.tabletitle}`}>TNPSC Group IV Test Batch 2024</h1>
                {/* <h1 className={`${styles.tabletitle}`}>(General Mental Ability & General Tamil)</h1> */}
                </div>
                <div className={`${styles.tablescroll} prelimstable`}>
                    <table className="table">
                        <thead className={`${styles.table1}`} >
                            <tr>
                                <td className={`${styles.tableheading}`}>Center<br /></td>
                                <td className={`${styles.tableheading}`}>Batch<br /></td>
                                <td className={`${styles.tableheading}`}>Starts On<br /></td>
                                <td className={`${styles.tableheading}`}>Fee<br /></td>
                                <td className={`${styles.tableheading}`}>English Schedule<br /></td>
                                <td className={`${styles.tableheading}`}>Tamil Schedule<br /></td>
                                <td className={`${styles.tableheading}`}>Payment<br /></td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr className="pt-2">
                                <td className={`${styles.tablepara} border-0`}>Chennai - Anna Nagar<br /></td>
                                <td className={`${styles.tablepara}`}>Batch IV Regular(Online/Offline)</td>
                                <td className={`${styles.tablepara}`}>3rd February 2024<br /></td>
                                <td className={`${styles.tablepara}`}>₹5000 (For new students)<br />₹4500 (For Old students)</td>
                                <td><Link href="/pdf/tnpsc-groupiv-testbatch-2023/EnglishBatch 4.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                                {/* <td><Link href="#" target="_blank" className={`${styles.paybill}`}>Click here</Link></td> */}
                                <td> - </td>
                                <td className="border-0"><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                            </tr>
                            <tr className="pt-2">
                                <td className={`${styles.tablepara}`}><br /></td>
                                <td className={`${styles.tablepara}`}>Batch V Regular(Online/Offline)</td>
                                <td className={`${styles.tablepara}`}>7th February 2024<br /></td>
                                <td className={`${styles.tablepara}`}>₹5000 (For new students)<br />₹4500 (For Old students)</td>
                                <td><Link href="/pdf/tnpsc-groupiv-testbatch-2023/annanagar/Group IV - Test Series - Annanagar Batch 5.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                                {/* <td><Link href="#" target="_blank" className={`${styles.paybill}`}>Click here</Link></td> */}
                                <td> - </td>
                                <td className=""></td>
                            </tr>
                            <tr className="pt-2">
                                <td className={`${styles.tablepara}`}>Chennai - Adyar<br /></td>
                                <td className={`${styles.tablepara}`}>Regular(Offline)<br /></td>
                                <td className={`${styles.tablepara}`}>3rd February 2024<br /></td>
                                <td className={`${styles.tablepara}`}>₹5000 (For new students)<br />₹4500 (For Old students)</td>
                                <td><Link href="/pdf/tnpsc-groupiv-testbatch-2023/GROUP IV TEST BATCH- ADYAR (AFTER NOTIFICATION) (1).pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                                <td>-</td>
                                <td><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                            </tr>
                            <tr className="pt-2">
                                <td className={`${styles.tablepara}`}>Salem<br /></td>
                                <td className={`${styles.tablepara}`}>Regular(Online/Offline)<br /></td>
                                <td className={`${styles.tablepara}`}>5th February 2024<br /></td>
                                <td className={`${styles.tablepara}`}>₹5000 (For new students)<br />₹4500 (For Old students)</td>
                                <td><Link href="/pdf/tnpsc-groupiv-testbatch-2023/Group IV New Batch - Salem After Notification.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                                {/* <td><Link href="/pdf/tnpsc-groupiv-testbatch-2023/salem/Gr-IV-Batch-I-Updated-schedule-Tamil-1.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td> */}
                                <td>-</td>
                                <td><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                            </tr>

                            <tr className="pt-2">
                                <td className={`${styles.tablepara}`}>Thiruvarur<br /></td>
                                <td className={`${styles.tablepara}`}>Regular(Offline)<br /></td>
                                <td className={`${styles.tablepara}`}>5th February 2024<br /></td>
                                <td className={`${styles.tablepara}`}>₹5000 (For new students)<br />₹4500 (For Old students)</td>
                                <td><Link href="/pdf/tnpsc-groupiv-testbatch-2023/thiruvarur/TNPSC GROUP IV – Thiruvarur TEST BATCH SCHEDULE 2024_NEW BATCH.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                                <td>-</td>
                                <td className=""><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                            </tr>

                            <tr className="pt-2">
                                <td className={`${styles.tablepara}`}>Coimbatore<br /></td>
                                <td className={`${styles.tablepara}`}>Regular(Offline)<br /></td>
                                <td className={`${styles.tablepara}`}>6th February 2024<br /></td>
                                <td className={`${styles.tablepara}`}>₹5000 (For new students)<br />₹4500 (For Old students)</td>
                                <td><Link href="/pdf/tnpsc-groupiv-testbatch-2023/Group IV New Batch - After Notification _coimbatored.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                                <td>-</td>
                                <td className=""><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                            </tr>

                            <tr className="pt-2">
                                <td className={`${styles.tablepara}`}>Trichy<br /></td>
                                <td className={`${styles.tablepara}`}>Batch III Regular(Offline)<br /></td>
                                <td className={`${styles.tablepara}`}>20th January 2024<br /></td>
                                <td className={`${styles.tablepara}`}>₹4500 (For new students)<br />₹4000 (For Old students)</td>
                                {/* <td><Link href="/" target="_blank" className={`${styles.paybill}`}>Click here</Link></td> */}
                                <td><Link href="/pdf/tnpsc-groupiv-testbatch-2023/TNPSC-GRP-IV-TEST-BATCH-3-SCHEDULE-Trichy.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                                <td>-</td>
                                <td className=""><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                            </tr>

                            <tr className="pt-2">
                                <td className={`${styles.tablepara}`}>Madurai<br /></td>
                                <td className={`${styles.tablepara}`}>Batch II Regular(Offline)<br /></td>
                                <td className={`${styles.tablepara}`}>24th January 2024<br /></td>
                                <td className={`${styles.tablepara}`}>₹4500 (For new students)<br />₹4000 (For Old students)</td>
                                {/* <td><Link href="/" target="_blank" className={`${styles.paybill}`}>Click here</Link></td> */}
                                <td className='text-center'>-</td>
                                <td><Link href="/pdf/tnpsc-groupiv-testbatch-2023/GRP-IV-Regular-Test-Batch-02-Final-Tamil-Offline-madurai.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                                <td className=""><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                            </tr>

                            <tr className="pt-2">
                                <td className={`${styles.tablepara}`}>Namakkal<br /></td>
                                <td className={`${styles.tablepara}`}>Regular (Offline /Online) <br /></td>
                                <td className={`${styles.tablepara}`}>08th February 2024<br /></td>
                                <td className={`${styles.tablepara}`}>₹5000 (For new students)<br />₹4500 (For Old students)</td>
                                <td><Link href="/pdf/tnpsc-groupiv-testbatch-2023/Gr IV Batch 2 schedule - Namakkal.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                                <td>-</td>
                                <td className=""><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                            </tr>

                            {/* <tr className="pt-2">
                                <td className={`${styles.tablepara}`}>Namakkal<br /></td>
                                <td className={`${styles.tablepara}`}>Regular (Offline /Online) <br /></td>
                                <td className={`${styles.tablepara}`}>08th February 2024<br /></td>
                                <td className={`${styles.tablepara}`}>₹5000 (For new students)<br />₹4500 (For Old students)</td>
                                <td><Link href="/pdf/tnpsc-groupiv-testbatch-2023/Gr IV Batch 2 schedule - Namakkal.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                                <td>-</td>
                                <td className=""><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                            </tr> */}
                            
                        </tbody>
                    </table>
                </div>
            </div>

            <Footer />
        </>
    )
}

export default Tnpsc_gr_IV_testbatch;